import { render, staticRenderFns } from "./DashboardRevenueSplit.vue?vue&type=template&id=75562c06&scoped=true"
import script from "./DashboardRevenueSplit.vue?vue&type=script&lang=js"
export * from "./DashboardRevenueSplit.vue?vue&type=script&lang=js"
import style0 from "./DashboardRevenueSplit.vue?vue&type=style&index=0&id=75562c06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75562c06",
  null
  
)

export default component.exports